import { emptyArray, useFetcher, useSWRWithDefaults } from "@app/lib/swr/swr";
import type { PokeConditionalFetchProps } from "@app/poke/swr/types";
import type { PokeListSuggestions } from "@app/types/api/poke/agent_configurations";
import type { Fetcher } from "swr";

interface PokeSuggestionsFetchProps extends PokeConditionalFetchProps {
  agentId: string;
}

export function usePokeSuggestions({
  disabled,
  owner,
  agentId,
}: PokeSuggestionsFetchProps) {
  const { fetcher } = useFetcher();
  const suggestionsFetcher: Fetcher<PokeListSuggestions> = fetcher;

  const { data, error, mutate } = useSWRWithDefaults(
    `/api/poke/workspaces/${owner.sId}/assistants/${agentId}/suggestions`,
    suggestionsFetcher,
    { disabled }
  );

  return {
    data: data?.suggestions ?? emptyArray(),
    isLoading: !error && !data && !disabled,
    isError: !!error,
    mutate,
  };
}
